import { BankIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Landmark = /* @__PURE__ */ createIcon(BankIcon, 'Landmark');
